import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './missouri-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-missouri',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    CommonModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    TruncateModule,
    TooltipModule
  ],
  templateUrl: './missouri.component.html',
  styleUrl: './missouri.component.scss',
})
export class MissouriComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('missouri', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('missouri', null);
    }
  }

  dynamicLimitId: Object = {
    UM_CombinedSingleMinLimit_DropDown: 'um_combinedsingleminlimit_50k',
    UM_SplitMinLimits_DropDown: 'um_splitminlimits_25k_50k',
    UIM_CombinedSingleMinLimit_DropDown: 'uim_combinedsingleminlimit_50k',
    UIM_SplitMinLimits_DropDown: 'uim_splitminlimits_50k_100k',
  };
}
